import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
class Disableable {
  constructor(component) {
    this.component = component;
  }
  isDisabled() {
    return this.component.classList.contains('--disabled');
  }
  setDisabled(isDisabled) {
    var _this$component$contr;
    if (this.namespace) iamotaEventHandler.trigger("".concat(this.namespace, ":disabling"), {
      component: this
    }, {
      context: this
    });
    this.component.classList.toggle('--disabled', isDisabled);
    this.component.setAttribute('aria-disabled', isDisabled);
    (_this$component$contr = this.component.controls) === null || _this$component$contr === void 0 || _this$component$contr.forEach(control => {
      control.classList.toggle('--disabled', isDisabled);
      control.disabled = isDisabled;
      control.setAttribute('aria-disabled', isDisabled);
    });
    if (this.namespace) iamotaEventHandler.trigger("".concat(this.namespace, ":disabled"), {
      component: this
    }, {
      context: this
    });
  }
  disable() {
    this.setDisabled(true);
  }
  enable() {
    this.setDisabled(false);
  }
}
export default Disableable;